import { useTranslation } from "../i18n";
import InboundAdmin from "../components/InboundAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin > Warehouse > Inbound — the inbound pallet dashboard. Mirrors
// admin-inventory.tsx: header + hint, all the work is in the component.
const AdminInboundPage = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="inbound_admin_title"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "inbound_admin_title" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("inbound_admin_hint")}</p>
                <InboundAdmin />
            </div>
        </div>
    );
};

export default AdminInboundPage;
